export default __webpack_public_path__ + "static/simple-pie-2ee9dba0a03ef69d03752dca914a6801.png";